const SCROLL_OFFSET_Y = 60;
export const SCROLL_OFFSET: [number, number] | (() => [number, number]) = [0, SCROLL_OFFSET_Y];
